// action types

export const COUNTRY_AND_LANGUAGE_UPDATED = 'i18n/SET_COUNTRY_AND_LANGUAGE'
export const LANGUAGE_UPDATED = 'i18n/LANGUAGE_UPDATED'
export const COUNTRY_UPDATED = 'i18n/COUNTRY_UPDATED'
export const TRANSLATIONS_UPDATED = 'i18n/TRANSLATIONS_UPDATED'

export const GEO_REQUESTED = 'location/GEO_REQUESTED'
export const GEO_UPDATED = 'location/GEO_UPDATED'
export const GEO_CLEARED = 'location/GEO_CLEARED'
